const normalizeName = (name) => String(name).trim().toLowerCase().replace(/\s+/g, '');

// Retrouve la ligne de saisie correspondant à une ligne importée : d'abord par matricule,
// puis, à défaut, par nom sans tenir compte de la casse ni des espaces. Retourne -1 si rien ne correspond.
export function findInputIndex(inputs, row) {
    if (row.matricule) {
        const matriculeIndex = inputs.findIndex(item => String(item.matricule).trim() === row.matricule);
        if (matriculeIndex !== -1) return matriculeIndex;
    }
    if (!row.name) return -1;

    const normalizedName = normalizeName(row.name);
    return inputs.findIndex(item => normalizeName(item.name) === normalizedName);
}
